import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'localizedDate',
  pure:false
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  private formattedDate='';
  private initialDate: any;
  private initialLanguage: string;

  transform(value: any, format = 'd MMMM y, HH:mm'): any {

    if(this.initialDate === value && this.initialLanguage === this.translateService.currentLang){
      return this.formattedDate;
    }

    const datePipe = new DatePipe(this.translateService.currentLang);
    const calculatedLocalDate = value;

    if(this.initialDate == null){
      const timeOffsetInMS = calculatedLocalDate.getTimezoneOffset() * -60000;
      calculatedLocalDate.setTime(calculatedLocalDate.getTime() + timeOffsetInMS);
    }

    this.initialDate = value;
    this.initialLanguage = this.translateService.currentLang;
    this.formattedDate = datePipe.transform(calculatedLocalDate, format);

    return this.formattedDate;
  }
}


